import { Outlet } from 'react-router-dom'

import { Menu } from '~/components/Organisms/Menu'

import { ProtectedRoute } from '~/lib/auth'

export function DrawerLayout() {
  return (
    <ProtectedRoute>
      <Menu>
        <Outlet />
      </Menu>
    </ProtectedRoute>
  )
}
